export default "__VITE_ASSET__D5eWTfvs__"